import { jsxs, jsx } from 'react/jsx-runtime';
import cx from 'clsx';
import { useRef, useCallback, useEffect } from 'react';
import { u as useCssVariable } from './hook-C_LtjIcQ.js';
import { s as styleInject } from './style-inject.es-tgCJW-Cu.js';

const COLLAPSIBLE_TRANSITION_DURATION_MS_DEFAULT = 300;

var css_248z = ".SGCM_UIKIT_REACT_Collapsible_detailsRoot_1coqm_1 {\n  width: 100%;\n}\n\n.SGCM_UIKIT_REACT_Collapsible_containerSummary_1coqm_5 {\n  cursor: pointer;\n}\n\n.SGCM_UIKIT_REACT_Collapsible_containerContent_1coqm_9 {\n  overflow: var(--collapsible-overflow-height);\n  max-height: var(--collapsible-content-max-height);\n  transition: max-height var(--collapsible-transition-duration-ms) ease-out;\n}\n.SGCM_UIKIT_REACT_Collapsible_containerContent_1coqm_9.SGCM_UIKIT_REACT_Collapsible_isDefaultOpen_1coqm_14 {\n  max-height: var(--collapsible-content-max-height);\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFdBQVc7QUFDYjs7QUFFQTtFQUNFLGVBQWU7QUFDakI7O0FBRUE7RUFDRSw0Q0FBNEM7RUFDNUMsaURBQWlEO0VBQ2pELHlFQUF5RTtBQUMzRTtBQUNBO0VBQ0UsaURBQWlEO0FBQ25EIiwiZmlsZSI6InN0eWxlcy5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5kZXRhaWxzUm9vdCB7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG4uY29udGFpbmVyU3VtbWFyeSB7XG4gIGN1cnNvcjogcG9pbnRlcjtcbn1cblxuLmNvbnRhaW5lckNvbnRlbnQge1xuICBvdmVyZmxvdzogdmFyKC0tY29sbGFwc2libGUtb3ZlcmZsb3ctaGVpZ2h0KTtcbiAgbWF4LWhlaWdodDogdmFyKC0tY29sbGFwc2libGUtY29udGVudC1tYXgtaGVpZ2h0KTtcbiAgdHJhbnNpdGlvbjogbWF4LWhlaWdodCB2YXIoLS1jb2xsYXBzaWJsZS10cmFuc2l0aW9uLWR1cmF0aW9uLW1zKSBlYXNlLW91dDtcbn1cbi5jb250YWluZXJDb250ZW50LmlzRGVmYXVsdE9wZW4ge1xuICBtYXgtaGVpZ2h0OiB2YXIoLS1jb2xsYXBzaWJsZS1jb250ZW50LW1heC1oZWlnaHQpO1xufVxuXG46ZXhwb3J0IHtcbiAgY29udGVudE1heEhlaWdodFZhck5hbWU6IC0tY29sbGFwc2libGUtY29udGVudC1tYXgtaGVpZ2h0O1xuICBjb250ZW50T3ZlcmZsb3dWYXJOYW1lOiAtLWNvbGxhcHNpYmxlLW92ZXJmbG93LWhlaWdodDtcbiAgY29udGVudFRyYW5zaXRpb25EdXJhdGlvblZhck5hbWU6IC0tY29sbGFwc2libGUtdHJhbnNpdGlvbi1kdXJhdGlvbi1tcztcbn0iXX0= */";
var styles = {"contentMaxHeightVarName":"--collapsible-content-max-height","contentOverflowVarName":"--collapsible-overflow-height","contentTransitionDurationVarName":"--collapsible-transition-duration-ms","detailsRoot":"SGCM_UIKIT_REACT_Collapsible_detailsRoot_1coqm_1","containerSummary":"SGCM_UIKIT_REACT_Collapsible_containerSummary_1coqm_5","containerContent":"SGCM_UIKIT_REACT_Collapsible_containerContent_1coqm_9","isDefaultOpen":"SGCM_UIKIT_REACT_Collapsible_isDefaultOpen_1coqm_14"};
styleInject(css_248z);

const Collapsible = ({ children, className, isOpen, summary, isContentOverflowVisible, transitionDurationMs = COLLAPSIBLE_TRANSITION_DURATION_MS_DEFAULT, onChange, }) => {
    const detailsElRef = useRef(null);
    const contentElRef = useRef(null);
    const isInitializedRef = useRef(false);
    const { setCssVariable: setDetailsCssVariable } = useCssVariable({
        targetElRef: detailsElRef,
    });
    const updateContentMaxHeight = useCallback(() => {
        const { current: contentEl } = contentElRef;
        if (!contentEl) {
            return;
        }
        const { contentOverflowVarName, contentMaxHeightVarName, contentTransitionDurationVarName, } = styles;
        setDetailsCssVariable(contentOverflowVarName, isContentOverflowVisible ? 'visible' : 'hidden');
        setDetailsCssVariable(contentTransitionDurationVarName, `${transitionDurationMs}ms`);
        const { scrollHeight } = contentEl;
        setDetailsCssVariable(contentMaxHeightVarName, `${isOpen ? scrollHeight : 0}px`);
    }, [
        isContentOverflowVisible,
        isOpen,
        setDetailsCssVariable,
        transitionDurationMs,
    ]);
    const onCollapsibleMaxHeightToggle = useCallback(() => {
        const { current: contentEl } = contentElRef;
        if (!contentEl || !isInitializedRef.current) {
            return;
        }
        const { contentOverflowVarName, contentMaxHeightVarName, contentTransitionDurationVarName, } = styles;
        setDetailsCssVariable(contentOverflowVarName, isContentOverflowVisible ? 'visible' : 'hidden');
        setDetailsCssVariable(contentTransitionDurationVarName, `${transitionDurationMs}ms`);
        const { scrollHeight } = contentEl;
        const { setTimeout, clearTimeout } = window;
        setDetailsCssVariable(contentMaxHeightVarName, `${isOpen ? scrollHeight : 0}px`);
        const timerId = setTimeout(() => {
            setDetailsCssVariable(contentMaxHeightVarName, `${isOpen ? 0 : scrollHeight}px`);
            clearTimeout(timerId);
        }, 0);
    }, [
        isContentOverflowVisible,
        isOpen,
        setDetailsCssVariable,
        transitionDurationMs,
    ]);
    useEffect(() => {
        const { current: contentEl } = contentElRef;
        if (!contentEl || isInitializedRef.current) {
            return;
        }
        setDetailsCssVariable(styles.contentMaxHeightVarName, `${isOpen ? contentEl.scrollHeight : 0}px`);
        isInitializedRef.current = true;
    }, [
        isOpen,
        setDetailsCssVariable,
    ]);
    useEffect(() => {
        updateContentMaxHeight();
    }, [children, updateContentMaxHeight]);
    const onCollapsibleToggle = () => {
        onCollapsibleMaxHeightToggle();
        onChange?.(!isOpen);
    };
    return (jsxs("div", { ref: detailsElRef, className: cx(styles.detailsRoot, className), children: [jsx("div", { className: styles.containerSummary, role: "button", tabIndex: 0, onClick: onCollapsibleToggle, onKeyDown: onCollapsibleToggle, children: summary }), jsx("div", { ref: contentElRef, className: styles.containerContent, onTransitionEnd: ({ propertyName }) => {
                    if (propertyName !== 'max-height' || !isOpen) {
                        return;
                    }
                    if (isContentOverflowVisible) {
                        setDetailsCssVariable(styles.contentOverflowVarName, 'visible');
                    }
                    setDetailsCssVariable(styles.contentMaxHeightVarName, 'unset');
                }, children: children })] }));
};

export { Collapsible as C, COLLAPSIBLE_TRANSITION_DURATION_MS_DEFAULT as a };
//# sourceMappingURL=component-DjKjkrda.js.map
